import * as React from 'react';
import { SVGProps } from 'react';

const BubbleDropdownIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 118 148" {...props}>
    <g opacity="0.4">
      <g clipPath="url(#clip0_642_48299)">
        <path
          stroke="#fff"
          strokeWidth="4.637"
          d="M37.524 96.504h0l.006.002a21.72 21.72 0 11-27.574 13.539l.008-.024a21.708 21.708 0 0127.56-13.517z"
        ></path>
        <path
          fill="#F2F3F3"
          d="M23.615 133.827a16.902 16.902 0 01-10.93-12.761 16.562 16.562 0 01-.142-5.471c.12-.84.302-1.669.544-2.482.105-.482.308-.936.598-1.335a2.331 2.331 0 012.317-.86 2.402 2.402 0 011.904 2.881c-.09.4-.246.778-.343 1.175a12.348 12.348 0 00-.363 2.599 11.812 11.812 0 00.714 4.421 12.042 12.042 0 006.018 6.739c.402.202.819.375 1.246.516.63.184 1.162.61 1.479 1.185a2.406 2.406 0 01-1.596 3.496 2.39 2.39 0 01-.939.018l-.092-.019a2.539 2.539 0 01-.411-.113"
        ></path>
      </g>
      <g clipPath="url(#clip1_642_48299)">
        <path
          stroke="#fff"
          strokeWidth="4.637"
          d="M121.056 71.007h.001l.005.001a20.245 20.245 0 0115.172 16.616 20.252 20.252 0 01-20.938 23.274 20.247 20.247 0 01-18.122-13.336 20.25 20.25 0 01-.62-11.74l.006-.023a20.236 20.236 0 0124.496-14.792z"
        ></path>
        <path
          fill="#F2F3F3"
          d="M111.734 106.549a15.877 15.877 0 01-11.267-11.04 15.556 15.556 0 01-.58-5.106c.043-.794.146-1.585.306-2.365.058-.459.212-.9.45-1.298a2.19 2.19 0 012.096-.994 2.257 2.257 0 012.017 2.54c-.051.381-.167.746-.225 1.126a11.58 11.58 0 00-.127 2.46c.08 1.413.43 2.796 1.03 4.077a11.308 11.308 0 006.179 5.81c.393.156.796.283 1.208.38a2.33 2.33 0 011.48.988c.286.425.416.937.368 1.448a2.26 2.26 0 01-1.575 1.952c-.283.088-.581.12-.876.093l-.088-.01a2.396 2.396 0 01-.394-.072"
        ></path>
      </g>
      <g clipPath="url(#clip2_642_48299)">
        <path
          stroke="#fff"
          strokeWidth="4.637"
          d="M106.235 20.256h.005a13.913 13.913 0 11-15.436 12.201l.002-.016a13.903 13.903 0 0115.429-12.185z"
        ></path>
        <path
          fill="#F2F3F3"
          d="M103.402 45.318a11.413 11.413 0 01-9.03-6.866 11.185 11.185 0 01-.867-5.307c0-.333.07-.662.205-.966a1.573 1.573 0 011.406-.898 1.623 1.623 0 011.667 1.631c-.002.277-.052.548-.06.824-.019.592.025 1.185.131 1.767.184 1 .558 1.957 1.101 2.817a8.131 8.131 0 004.931 3.59c.294.077.594.131.896.163.442.032.854.238 1.145.572.242.278.381.632.393 1a1.627 1.627 0 01-1.566 1.68l-.064.001a1.721 1.721 0 01-.287-.017"
        ></path>
      </g>
      <g clipPath="url(#clip3_642_48299)">
        <path
          stroke="#fff"
          strokeWidth="4.637"
          d="M45.218 1.189h.005a13.913 13.913 0 11-15.436 12.2l.002-.016A13.904 13.904 0 0145.22 1.19z"
        ></path>
        <path
          fill="#F2F3F3"
          d="M42.386 26.25a11.413 11.413 0 01-9.031-6.866 11.186 11.186 0 01-.867-5.306c0-.333.07-.662.205-.966a1.573 1.573 0 011.407-.898 1.623 1.623 0 011.667 1.63c-.002.278-.052.549-.06.825-.02.592.024 1.184.13 1.767.185 1 .558 1.956 1.102 2.816a8.13 8.13 0 004.93 3.59c.295.077.594.132.896.164.443.032.854.237 1.145.572.243.278.382.631.393 1a1.626 1.626 0 01-1.565 1.68h-.064a1.714 1.714 0 01-.287-.016"
        ></path>
      </g>
      <g clipPath="url(#clip4_642_48299)">
        <path
          stroke="#fff"
          strokeWidth="4.637"
          d="M75.87 40.847h0l.007.003A27.12 27.12 0 1140.512 55.69l.011-.029A27.103 27.103 0 0175.87 40.847z"
        ></path>
        <path
          fill="#F2F3F3"
          d="M55.97 85.947a20.701 20.701 0 01-12.438-16.389 20.288 20.288 0 01.223-6.699 20.94 20.94 0 01.844-2.994 4.353 4.353 0 01.827-1.59 2.853 2.853 0 012.895-.883 2.944 2.944 0 012.12 3.66c-.14.483-.358.932-.506 1.411a15.127 15.127 0 00-.631 3.151 14.47 14.47 0 00.554 5.457 14.746 14.746 0 006.868 8.672c.477.276.974.517 1.487.72.757.271 1.376.83 1.722 1.557.288.604.359 1.289.2 1.939a2.944 2.944 0 01-3.553 2.173l-.111-.03a3.107 3.107 0 01-.494-.168"
        ></path>
      </g>
    </g>
    <defs>
      <clipPath id="clip0_642_48299">
        <path
          fill="#fff"
          d="M0 0H48.08V48.08H0z"
          transform="rotate(-161.15 35 70.014)"
        ></path>
      </clipPath>
      <clipPath id="clip1_642_48299">
        <path
          fill="#fff"
          d="M0 0H45.136V45.136H0z"
          transform="rotate(-166.15 73.53 50.932)"
        ></path>
      </clipPath>
      <clipPath id="clip2_642_48299">
        <path
          fill="#fff"
          d="M0 0H32.462V32.462H0z"
          transform="rotate(-173.323 60.948 22.575)"
        ></path>
      </clipPath>
      <clipPath id="clip3_642_48299">
        <path
          fill="#fff"
          d="M0 0H32.462V32.462H0z"
          transform="rotate(-173.323 29.884 14.82)"
        ></path>
      </clipPath>
      <clipPath id="clip4_642_48299">
        <path
          fill="#fff"
          d="M0 0H58.877V58.877H0z"
          transform="rotate(-157.766 51.117 44.142)"
        ></path>
      </clipPath>
    </defs>
  </svg>
);

export default BubbleDropdownIcon;
